import React from 'react';
import { Link } from 'react-router-dom';


const Navbar = () => {

    return (

        <div className="navbar bg-primary text-white ">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex="0" className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex="0" className="menu menu-compact text-black dropdown-content mt-3 p-2 shadow bg-cyan-100 rounded-box w-52">
                        <li><Link className='font-bold text-xl' to='/'>Home</Link></li>


                        <li><Link className='font-bold text-xl' to='/contact'>Contact Me</Link></li>
                        <li><Link className='font-bold text-xl' to='/about'>About Me</Link></li>
                        <li><Link className='font-bold text-xl' to='/blogs'> Blogs</Link></li>
                    </ul>
                </div>
                <Link to='' className="btn btn-ghost normal-case text-4xl italic ">Protfolio</Link>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal p-0">
                    <li><Link className='font-bold text-xl' to='/'>Home</Link></li>


                    <li><Link className='font-bold text-xl' to='/contact'>Contact Me</Link></li>
                    <li><Link className='font-bold text-xl' to='/about'>About Me</Link></li>
                    <li><Link className='font-bold text-xl' to='/blogs'> Blogs</Link></li>
                </ul>
            </div>
            <div className="navbar-end">
                <a href='https://docs.google.com/document/d/1YbWy4TAGu0azfJMFNH49Z9ScgaVCCp14FBOHuV0v33U/edit?usp=sharing' class="btn btn-primary">Download resume</a>

            </div>
        </div>

    );
};

export default Navbar;